import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class BlogPostActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/Blog/BlogPostBrowser.js")
	}

	render() {
		return (
			<Activity 
				name="BlogPostActivity"
				RenderedComponent={this.RenderedComponent}
				context="BlogPostActivity"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(BlogPostActivity)
